<template>
  <div class="user_login">
    <section class="text_center base_text_style">
      <h2 class="header_underline">ログイン</h2>

      <ValidationObserver ref="form">
        <form
          action=""
          method="post"
          class="form"
        >
          <div class="form_group">
            <ValidationProvider name="メールアドレス" rules="required" v-slot="{ errors }">
              <label>メールアドレス</label>
              <input
                type="email"
                name="email"
                placeholder="メールアドレスを入力してください"
                v-model="form.email"
              />
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider name="パスワード" rules="required|min:12" v-slot="{ errors }">
              <label>パスワード</label>
              <input
                type="password"
                name="password"
                placeholder="パスワードを入力してください"
                v-model="form.password"
              />
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <p v-if="form.errors.length > 0" class="form_error">
              <span v-for="(error, index) in form.errors" :key="index" class="valid_error">{{ error }}</span>
            </p>
            <p>
              <button
                type="submit"
                class="btn arrow"
                :disabled="isSend"
                @click.prevent="checkForm"
              >ログイン</button>
            </p>
            <p><a href="#" @click.prevent="$router.go(-1)" class="arrow link_main--text">トップページへ戻る</a></p>
          </div>
        </form>
      </ValidationObserver>
    </section>
  </div>
</template>

<script>
import { USER_LOGIN } from '@/store/user/actions'

import {
  ValidationObserver,
  ValidationProvider,
  extend
} from 'vee-validate'
import {
  required,
  min
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: '{_field_}を入力してください'
})

extend('min', {
  ...min,
  message: '{_field_}は{length}文字以上で入力してください'
})

export default {
  name: 'UserLogin',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      form: {
        errors: [],
        email: null,
        password: null
      },
      isSend: false
    }
  },
  methods: {
    checkForm () {
      if (this.isSend) return
      this.isSend = true

      this.$refs.form.validate().then(success => {
        if (success) {
          this.login()
        } else {
          this.isSend = false
        }
      })
    },
    login () {
      const params = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch(USER_LOGIN, params)
        .then((data) => {
          this.$router.push({ name: 'Top', query: { isses: data.access_cd } })
        })
        .catch((error) => {
          this.isSend = false
          this.form.errors = []

          let message = ''
          if (error.errorStatus === 400) {
            message = message + '\n' + error.message
          } else if (error.errorStatus === 422) {
            Object.keys(error.errorData).forEach((key) => {
              error.errorData[key].forEach(entry => {
                this.form.errors.push(entry)
              })
            })
          } else {
            message = error.message
          }

          this.form.errors.push(message)
        })
    }
  }
}
</script>
